export type TicketCategoryGroup = {
  main: string;
  categories: readonly string[];
};

export const TICKET_CATEGORY_CATALOG: readonly TicketCategoryGroup[] = [
  {
    main: "POS",
    categories: [
      "POS Terminal / Workstation",
      "Installation",
      "Credit Card Readers",
      "Printers",
      "Peripherals",
      "Network & Connectivity",
      "Application Error",
      "Menu & Item Setup",
      "Pricing, Discount & Tax",
      "Payment & Batch",
      "Receipt & Printing Layout",
      "User & Permission",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "KDS",
    categories: [
      "KDS Device",
      "Display & Layout",
      "Order Routing",
      "Bump & Undo",
      "Station & Item Setup",
      "Network & Connectivity",
      "Application Error",
      "User & Permission",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Kiosk",
    categories: [
      "Kiosk Device",
      "Card Reader",
      "Printers",
      "Screen & Branding",
      "Order Flow",
      "Menu & Item Setup",
      "Pricing, Discount & Tax",
      "Payment & Batch",
      "Network & Connectivity",
      "Application Error",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Online Ordering",
    categories: [
      "Website & Storefront",
      "Menu & Item Setup",
      "Pricing, Discount & Tax",
      "Payment & Checkout",
      "Order Flow",
      "Delivery & Pickup Setup",
      "Third-party Integration",
      "Notification & Email",
      "Application Error",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "QR - Code Dine-in",
    categories: [
      "QR Code Setup",
      "Table & Floor Plan",
      "Menu & Item Setup",
      "Pricing, Discount & Tax",
      "Payment & Checkout",
      "Order Flow",
      "Application Error",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Handheld (QOrder / SOrder)",
    categories: [
      "Device & App Installation",
      "Network & Connectivity",
      "Menu & Item Setup",
      "Order Flow",
      "Payment & Checkout",
      "Printers",
      "Application Error",
      "User & Permission",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Booking",
    categories: [
      "Booking Setup",
      "Service & Staff Setup",
      "Schedule & Availability",
      "Customer & Appointment",
      "Notification & Reminder",
      "Payment & Deposit",
      "Application Error",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Back Office / Dashboard",
    categories: [
      "Login & Access",
      "User & Permission",
      "Store & Location Setup",
      "Menu & Item Setup",
      "Pricing, Discount & Tax",
      "Employee & Payroll",
      "Inventory",
      "Application Error",
      "Reports & Data",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Payment Processing",
    categories: [
      "Credit / Debit Card",
      "Gift Card",
      "Loyalty & Rewards",
      "Cash",
      "Check",
      "House Account & Store Credit",
      "EBT / SNAP",
      "Mobile Wallet (Apple Pay / Google Pay)",
      "Split & Partial Payment",
      "Tip & Gratuity",
      "Surcharge & Cash Discount",
      "Refund & Void",
      "Batch & Settlement",
      "Chargeback & Dispute",
      "Processor & Gateway Integration",
      "Terminal & Pinpad Setup",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Blogic View Report",
    categories: [
      "Access & Login",
      "Dashboard & KPI",
      "Sales Report",
      "Payment & Batch Report",
      "Employee & Payroll Report",
      "Tip & Gratuity Report",
      "Inventory Report",
      "Tax Report",
      "Customer & Loyalty Report",
      "Multi-store & Consolidated Report",
      "Data Accuracy & Mismatch",
      "Export & Scheduled Email",
      "Custom Report Request",
      "Application Error",
      "Feature Request",
      "Other",
    ],
  },
  {
    main: "Other",
    categories: [
      "General Inquiry",
      "Account & Billing",
      "Hardware Order / RMA",
      "Training Request",
      "Feature Request",
      "Other",
    ],
  },
];

export type TicketCategoryOption = readonly [string, string];

export const TICKET_MAIN_CATEGORY_OPTIONS: readonly TicketCategoryOption[] =
  TICKET_CATEGORY_CATALOG.map((g) => [g.main, g.main] as TicketCategoryOption);

export function ticketCategoryOptions(mainCategory: string): readonly TicketCategoryOption[] {
  const group = TICKET_CATEGORY_CATALOG.find((g) => g.main === mainCategory);
  return (group?.categories ?? []).map((c) => [c, c] as TicketCategoryOption);
}

export function withCurrentValue(
  options: readonly TicketCategoryOption[],
  value: string | null | undefined,
): readonly TicketCategoryOption[] {
  if (!value || options.some(([v]) => v === value)) return options;
  return [[value, value] as TicketCategoryOption, ...options];
}
